import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

const RoomPreview = ({
  id,
  image,
  className,
  roomExpandIconClassName,
  goToRoomDetail,
  roomPreviewId,
}) => {
  return (
    <div
      className={`${className} ${styles.roomPreview}`}
      id={roomPreviewId}
      onClick={ () => goToRoomDetail(id) }
    >
      {image && <img src={image} alt={id}/>}
      {/* <div
        className={`${roomExpandIconClassName} ${styles.roomPreviewExpandIcon}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.34 22.43">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <g>
                <path
                  d="M1,15.41v6H7"
                  style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px'}}/>
                <path
                  d="M1.64,20.91l6.3-6.3"
                  style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px'}}/>
                <path
                  d="M21.34,7V1h-6"
                  style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px'}}/>
                <path
                  d="M20.82,1.53l-6.3,6.3"
                  style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px'}}/>
              </g>
            </g>
          </g>
        </svg>
      </div> */}
    </div>
  )
};

RoomPreview.propTypes = {
  id: PropTypes.string,
  image: PropTypes.string,
  className: PropTypes.string,
  roomExpandIconClassName: PropTypes.string,
  goToRoomDetail: PropTypes.func,
}

export default RoomPreview;